import React, { Component } from 'react';
import {
    Alert,
    Badge,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table
} from 'reactstrap';
import { withRouter } from "react-router-dom";

import { CertificateAPI } from "api";
import { Utils } from "custom";

const moment = require("moment");

const LEVELS_WITHOUT_HOREN = ["A1", "A2"];

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());
const isValidBirthDate = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v || "");

class TabCertificate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            list: [],
            // regen modal
            regenOpen: false,
            regenCert: null,
            regenForm: {
                firstname: "", lastname: "", email: "",
                birth_date: "", birth_place: "",
                scores: { lesen: "", sprechen: "", schreiben: "", horen: "" }
            },
            regenError: ""
        };
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const clientId = this.props.client.id;
        this.setState({ loading: true, error: false });

        CertificateAPI.listByClient(clientId).then((list) => {
            this.setState({ list, loading: false });
        }).catch((e) => {
            console.error(e);
            this.setState({ loading: false, error: true });
        });
    };

    handleDownload = (cert) => {
        CertificateAPI.download(cert.id).catch((e) => {
            console.error(e);
            global.SweetAlert.fire({
                icon: 'error',
                title: 'Download fallito',
                text: 'Non è stato possibile scaricare l\'attestato.',
                customClass: { confirmButton: 'btn btn-danger' }
            });
        });
    };

    handleResend = (cert) => {
        global.SweetAlert.fire({
            title: 'Reinviare l\'attestato?',
            text: `Verrà inviata una nuova email al corsista con l'attestato ${cert.level?.macro || cert.level?.name} in allegato.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si, invia',
            cancelButtonText: 'Annulla',
            customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-secondary ms-1' },
            buttonsStyling: false
        }).then((r) => {
            if (!r.value) return;
            CertificateAPI.resend(cert.id).then(() => {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Email inviata',
                    customClass: { confirmButton: 'btn btn-success' }
                });
            }).catch((e) => {
                console.error(e);
                let msg = 'Non è stato possibile inviare l\'email.';
                if (e?.status === "CLIENT_EMAIL_MISSING") msg = "Il cliente non ha un'email impostata.";
                global.SweetAlert.fire({
                    icon: 'error',
                    title: 'Invio fallito',
                    text: msg,
                    customClass: { confirmButton: 'btn btn-danger' }
                });
            });
        });
    };

    openRegen = (cert) => {
        const client = this.props.client;
        this.setState({
            regenOpen: true,
            regenCert: cert,
            regenError: "",
            regenForm: {
                firstname: client.firstname || "",
                lastname: client.lastname || "",
                email: client.email || "",
                birth_date: client.birth_date || "",
                birth_place: client.birth_place || "",
                scores: { lesen: "", sprechen: "", schreiben: "", horen: "" }
            }
        });
    };

    closeRegen = () => this.setState({ regenOpen: false, regenCert: null });

    updateRegenField = (field, value) => {
        this.setState((s) => ({ regenForm: { ...s.regenForm, [field]: value } }));
    };

    updateRegenScore = (key, value) => {
        let v = value;
        if (v !== "") {
            v = Number(v);
            if (Number.isNaN(v)) v = "";
            if (v !== "" && v < 1) v = 1;
            if (v !== "" && v > 10) v = 10;
        }
        this.setState((s) => ({
            regenForm: { ...s.regenForm, scores: { ...s.regenForm.scores, [key]: v } }
        }));
    };

    submitRegen = () => {
        const { regenCert, regenForm } = this.state;
        const macro = regenCert?.level?.macro || "";
        const needsHoren = !LEVELS_WITHOUT_HOREN.includes(macro);

        // validazione
        if (!regenForm.firstname.trim()) return this.setState({ regenError: "Il nome è obbligatorio." });
        if (!regenForm.lastname.trim()) return this.setState({ regenError: "Il cognome è obbligatorio." });
        if (!isValidEmail(regenForm.email)) return this.setState({ regenError: "Email non valida." });
        if (!isValidBirthDate(regenForm.birth_date)) return this.setState({ regenError: "Data di nascita non valida (YYYY-MM-DD)." });
        if (!regenForm.birth_place.trim()) return this.setState({ regenError: "Luogo di nascita obbligatorio." });

        const requiredScores = needsHoren ? ["lesen", "sprechen", "schreiben", "horen"] : ["lesen", "sprechen", "schreiben"];
        for (const k of requiredScores) {
            const v = regenForm.scores[k];
            if (v === "" || v === null || typeof v === "undefined")
                return this.setState({ regenError: `Tutti i voti sono obbligatori (manca ${k.toUpperCase()}).` });
            if (Number(v) < 1 || Number(v) > 10)
                return this.setState({ regenError: "I voti devono essere compresi tra 1 e 10." });
        }

        const payload = {
            firstname: regenForm.firstname.trim(),
            lastname: regenForm.lastname.trim(),
            email: regenForm.email.trim(),
            birth_date: regenForm.birth_date,
            birth_place: regenForm.birth_place.trim(),
            scores: {
                lesen: Number(regenForm.scores.lesen),
                sprechen: Number(regenForm.scores.sprechen),
                schreiben: Number(regenForm.scores.schreiben),
                ...(needsHoren ? { horen: Number(regenForm.scores.horen) } : {})
            }
        };

        this.setState({ regenError: "" });

        CertificateAPI.regenerate(regenCert.id, payload).then(() => {
            this.closeRegen();
            global.SweetAlert.fire({
                icon: 'success',
                title: 'Attestato rigenerato',
                text: 'Il nuovo PDF è stato salvato. Puoi scaricarlo o reinviarlo.',
                customClass: { confirmButton: 'btn btn-success' }
            });
            this.load();
        }).catch((e) => {
            console.error(e);
            this.setState({ regenError: e?.message || "Errore durante la rigenerazione." });
        });
    };

    renderRegenModal() {
        const { regenOpen, regenCert, regenForm, regenError } = this.state;
        if (!regenOpen || !regenCert) return null;

        const macro = regenCert.level?.macro || "";
        const needsHoren = !LEVELS_WITHOUT_HOREN.includes(macro);

        return (
            <Modal isOpen={regenOpen} toggle={this.closeRegen} size="lg" centered>
                <ModalHeader toggle={this.closeRegen}>
                    Rigenera attestato - {macro}
                </ModalHeader>
                <ModalBody>
                    {regenError ? <Alert color="danger">{regenError}</Alert> : null}

                    <p className="text-muted small mb-3">
                        Modifica i dati qui sotto e conferma per rigenerare il PDF.
                        I dati del cliente verranno aggiornati anche in anagrafica.
                    </p>

                    <Row className="g-3">
                        <Col md={6}>
                            <Label>Nome</Label>
                            <Input value={regenForm.firstname} onChange={(e) => this.updateRegenField("firstname", e.target.value)} />
                        </Col>
                        <Col md={6}>
                            <Label>Cognome</Label>
                            <Input value={regenForm.lastname} onChange={(e) => this.updateRegenField("lastname", e.target.value)} />
                        </Col>
                        <Col md={12}>
                            <Label>Email</Label>
                            <Input type="email" value={regenForm.email} onChange={(e) => this.updateRegenField("email", e.target.value)} />
                        </Col>
                        <Col md={6}>
                            <Label>Data di nascita</Label>
                            <Input type="date" value={regenForm.birth_date} onChange={(e) => this.updateRegenField("birth_date", e.target.value)} />
                        </Col>
                        <Col md={6}>
                            <Label>Luogo di nascita</Label>
                            <Input value={regenForm.birth_place} onChange={(e) => this.updateRegenField("birth_place", e.target.value)} />
                        </Col>
                    </Row>

                    <hr className="my-4" />
                    <h6 className="mb-3">Voti finali (1-10)</h6>

                    <Row className="g-3">
                        <Col md={needsHoren ? 3 : 4}>
                            <Label>LESEN</Label>
                            <Input type="number" min={1} max={10} value={regenForm.scores.lesen} onChange={(e) => this.updateRegenScore("lesen", e.target.value)} />
                        </Col>
                        <Col md={needsHoren ? 3 : 4}>
                            <Label>SPRECHEN</Label>
                            <Input type="number" min={1} max={10} value={regenForm.scores.sprechen} onChange={(e) => this.updateRegenScore("sprechen", e.target.value)} />
                        </Col>
                        <Col md={needsHoren ? 3 : 4}>
                            <Label>SCHREIBEN</Label>
                            <Input type="number" min={1} max={10} value={regenForm.scores.schreiben} onChange={(e) => this.updateRegenScore("schreiben", e.target.value)} />
                        </Col>
                        {needsHoren ? (
                            <Col md={3}>
                                <Label>HÖREN</Label>
                                <Input type="number" min={1} max={10} value={regenForm.scores.horen} onChange={(e) => this.updateRegenScore("horen", e.target.value)} />
                            </Col>
                        ) : null}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={this.closeRegen}>Annulla</Button>
                    <Button color="success" onClick={this.submitRegen}>Rigenera</Button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {
        const role = Utils.getUserData().role;
        const canManage = (role === "ADMIN" || role === "CONSULENT");

        return (
            <React.Fragment>
                <Row>
                    <Col xxl={12}>
                        <Card>
                            <CardHeader>
                                <h5 className="card-title mb-0">Attestati</h5>
                            </CardHeader>
                            <CardBody>
                                {this.state.loading ? (
                                    <div className="text-center text-muted p-4">Caricamento...</div>
                                ) : this.state.error ? (
                                    <Alert color="danger">Errore nel caricamento degli attestati.</Alert>
                                ) : this.state.list.length === 0 ? (
                                    <Alert color="info" className="mb-0">Nessun attestato presente per questo cliente.</Alert>
                                ) : (
                                    <div className="table-responsive">
                                        <Table hover className="align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Livello</th>
                                                    <th>Data rilascio</th>
                                                    <th className="text-end">Azioni</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.list.map((c) => (
                                                    <tr key={c.id}>
                                                        <td>
                                                            <Badge color="primary" className="fs-12">
                                                                {c.level?.macro || c.level?.name}
                                                            </Badge>
                                                            {c.level?.name && c.level.macro !== c.level.name ? (
                                                                <span className="text-muted small ms-2">({c.level.name})</span>
                                                            ) : null}
                                                        </td>
                                                        <td>{moment(c.createdAt).format("DD/MM/YYYY")}</td>
                                                        <td className="text-end">
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                className="me-1"
                                                                onClick={() => this.handleDownload(c)}
                                                            >
                                                                <i className="ri-download-line me-1" />Scarica
                                                            </Button>
                                                            {canManage ? (
                                                                <>
                                                                    <Button
                                                                        color="warning"
                                                                        size="sm"
                                                                        className="me-1"
                                                                        onClick={() => this.openRegen(c)}
                                                                    >
                                                                        <i className="ri-refresh-line me-1" />Rigenera
                                                                    </Button>
                                                                    <Button
                                                                        color="success"
                                                                        size="sm"
                                                                        onClick={() => this.handleResend(c)}
                                                                    >
                                                                        <i className="ri-mail-send-line me-1" />Email
                                                                    </Button>
                                                                </>
                                                            ) : null}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {this.renderRegenModal()}
            </React.Fragment>
        );
    }
}

export default withRouter(TabCertificate);
